import { css, keyframes } from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

const HIGHLIGHT_PULSE_DURATION = '2s';
const HIGHLIGHT_PULSE_RING_WIDTH = spacing(1);
const HIGHLIGHT_PULSE_COLOR = '--highlight-pulse-color';

export const HIGHLIGHT_PULSE_VARIANT = {
  BACKGROUND: 'background',
  RING: 'ring',
} as const;

export type HighlightPulseVariant =
  (typeof HIGHLIGHT_PULSE_VARIANT)[keyof typeof HIGHLIGHT_PULSE_VARIANT];

const backgroundHighlightPulse = keyframes`
  from {
    background-color: var(${HIGHLIGHT_PULSE_COLOR});
  }
  to {
    background-color: transparent;
  }
`;

const ringHighlightPulse = keyframes`
  from {
    box-shadow: 0 0 0 ${HIGHLIGHT_PULSE_RING_WIDTH} var(${HIGHLIGHT_PULSE_COLOR});
  }
  to {
    box-shadow: 0 0 0 ${HIGHLIGHT_PULSE_RING_WIDTH} transparent;
  }
`;

const KEYFRAMES_BY_VARIANT = {
  [HIGHLIGHT_PULSE_VARIANT.BACKGROUND]: backgroundHighlightPulse,
  [HIGHLIGHT_PULSE_VARIANT.RING]: ringHighlightPulse,
};

interface GetHighlightPulseAnimationArgs {
  variant: HighlightPulseVariant;
  color: string;
}

export const getHighlightPulseAnimation = ({
  variant,
  color,
}: GetHighlightPulseAnimationArgs) => css`
  ${HIGHLIGHT_PULSE_COLOR}: ${color};
  animation: ${KEYFRAMES_BY_VARIANT[variant]} ${HIGHLIGHT_PULSE_DURATION}
    ease-out;
`;
